module.exports = __webpack_public_path__ + "videos/simple-interface.92b38d1.webm";